// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__p--Tp","Open":"SideDrawer_Open__3XXsG","Close":"SideDrawer_Close__CV2LW","Logo":"SideDrawer_Logo__1CxV9"};